var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gf-ad-map"},[_c('div',{ref:"grefmap",staticClass:"col appMap my-2"})])}
var staticRenderFns = []

export { render, staticRenderFns }